import { useQuery } from "hooks/useQuery";
import { getStockPrice } from "../service";

export const useStockPrice = (name) => {
  const { isLoading, data } = useQuery({
    queryKey: ["stockPrice", name],
    queryFn: async () => {
      const response = await getStockPrice(name);
      return response;
    },
    enabled: Boolean(name),
  });

  return {
    isLoading,
    priceData: data || {},
  };
};
